import EtablissementBrancheCode from '@/generated/controls/etablissement/EtablissementBrancheCode.vue';
import {defineComponent} from "vue";

export default defineComponent({
    components: {},
    extends: EtablissementBrancheCode
})
